









import {computed, ComputedRef, defineComponent} from "@vue/composition-api";

export default defineComponent({
  name: "MoleculeProgressBar",
  props: {
    text: {type: String},
    progress: {type: Number, required: true, default: 0}
  },
  setup: (props) => {
    const style: ComputedRef<object> = computed(() => {
      return {
        width: `${props.progress}%`
      };
    });
      
    return {
      style
    }
  }
})
